import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { appLogger } from "../../../utils";
import BrandingBackgrountColor from "./BrandingBackgrountColor";
import BrandingCommonForm from "./BrandingCommonForm";
import BrandingInputField from "./BrandingInputField";
import BrandingFontSizeField from "./BrandingFontSizeField";
import { PLATFORM_TYPE_TV } from "../../../model";

const BrandingAgent = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "WidgetPreview",
      component: "add-product",
      fileName: "WidgetPreview.tsx",
      prpos: props,
    },
  });
  const { productParams, setProductParams } = props;

  // const handleCardBoderRadius = (event: any) => {
  //   const color = event.target.value
  //   if (productParams) {
  //     const temp: IProductParams | undefined = { ...productParams };
  //     if (temp && temp.products && temp.products[0] && temp.products[0].feedbackAgentSettings) {
  //       if (!temp.products[0].feedbackAgentSettings.branding) {
  //         temp.products[0].feedbackAgentSettings.branding = {}
  //       }
  //       temp.products[0].feedbackAgentSettings.branding["branding-cuvo-card-border-radius"] = color;
  //       setProductParams(temp);
  //     }
  //   }
  // };

  // const handleButtonBoderRadius = (event: any) => {
  //   const color = event.target.value
  //   if (productParams) {
  //     const temp: IProductParams | undefined = { ...productParams };
  //     if (temp && temp.products && temp.products[0] && temp.products[0].feedbackAgentSettings) {
  //       if (!temp.products[0].feedbackAgentSettings.branding) {
  //         temp.products[0].feedbackAgentSettings.branding = {}
  //       }
  //       temp.products[0].feedbackAgentSettings.branding["branding-cuvo-button-border-radius"] = color;
  //       setProductParams(temp);
  //     }
  //   }
  // };

  return (
    <>
      {/* ******************Form Appreance******************************** */}
      <Typography id={`colorStylingOptions`} sx={{ fontWeight: 500, mb: 1 }}>
        Form Appearance:
        <div className="fontfamiltnotemsg">
          Note: Font family in the Preview will works only for browser defined
          fonts
        </div>
      </Typography>
      <Grid container spacing={2} className="form-appearance-section">
        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Header Title Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <BrandingCommonForm
            productParams={productParams}
            setProductParams={setProductParams}
            field={"main-title"}
            textColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-title"
              ]
            }
            fontFamily={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-title-font-family"
              ]
            }
            fontSize={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-title-font-size"
              ]
            }
            fontStyle={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-title-font-style"
              ]
            }
            fontWeight={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-title-font-weight"
              ]
            }
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Header Sub-title Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <BrandingCommonForm
            productParams={productParams}
            setProductParams={setProductParams}
            field={"sub-title"}
            textColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-subtitle"
              ]
            }
            fontFamily={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-subtitle-font-family"
              ]
            }
            fontSize={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-subtitle-font-size"
              ]
            }
            fontStyle={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-subtitle-font-style"
              ]
            }
            fontWeight={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-main-subtitle-font-weight"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          {productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].platform != PLATFORM_TYPE_TV ? (
            <Typography className="title-sm brandingmain">
              Card Text Styles
            </Typography>
          ) : (
            <Typography className="title-sm brandingmain">
              Card Text Styles
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12}>
          <BrandingCommonForm
            productParams={productParams}
            setProductParams={setProductParams}
            field={"card-main-title"}
            textColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-card-title"
              ]
            }
            fontFamily={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-card-title-font-family"
              ]
            }
            fontSize={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-card-title-font-size"
              ]
            }
            fontStyle={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-card-title-font-style"
              ]
            }
            fontWeight={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-card-title-font-weight"
              ]
            }
          />
        </Grid>
        {/* {productParams && productParams.products && productParams.products[0] && productParams.products[0].platform != PLATFORM_TYPE_TV && */}
        <>
          <Grid item xs={12} sm={12}>
            <Typography className="title-sm brandingmain">
              Card Sub-title Styles
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            <BrandingCommonForm
              productParams={productParams}
              setProductParams={setProductParams}
              field={"card-sub-title"}
              textColor={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-popup-dialog-card-subtitle"
                ]
              }
              fontFamily={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-popup-dialog-card-subtitle-font-family"
                ]
              }
              fontSize={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-popup-dialog-card-subtitle-font-size"
                ]
              }
              fontStyle={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-popup-dialog-card-subtitle-font-style"
                ]
              }
              fontWeight={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-popup-dialog-card-subtitle-font-weight"
                ]
              }
            />
          </Grid>
        </>
        {/* } */}

        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Input Field Label Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <BrandingCommonForm
            productParams={productParams}
            setProductParams={setProductParams}
            field={"input-label"}
            textColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-label-color"
              ]
            }
            fontFamily={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-label-font-family"
              ]
            }
            fontSize={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-label-font-size"
              ]
            }
            fontStyle={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-label-font-style"
              ]
            }
            fontWeight={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-label-font-weight"
              ]
            }
          />
        </Grid>

        <>
          <Grid item xs={12} sm={12}>
            <Typography className="title-sm brandingmain">
              Attachment Helper Note Styles
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            <BrandingCommonForm
              productParams={productParams}
              setProductParams={setProductParams}
              field={"attachment-helper"}
              textColor={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-attachment-helper-color"
                ]
              }
              fontFamily={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-attachment-helper-font-family"
                ]
              }
              fontSize={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-attachment-helper-font-size"
                ]
              }
              fontStyle={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-attachment-helper-font-style"
                ]
              }
              fontWeight={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-attachment-helper-font-weight"
                ]
              }
            />
          </Grid>
        </>

        {/* ************************************ */}
        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Primary Button Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Primary Button"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-bg"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <BrandingInputField
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Primary Button Border Radius"}
            fieldValue={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary_btn-border-radius"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Primary Button Border"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-border-color"
              ]
            }
          />
        </Grid>
        {/* ****************************************** */}
        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Primary Button Text Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <BrandingCommonForm
            productParams={productParams}
            setProductParams={setProductParams}
            field={"primary-button"}
            textColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-text-color"
              ]
            }
            fontFamily={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-text-font-family"
              ]
            }
            fontSize={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-text-font-size"
              ]
            }
            fontStyle={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-text-font-style"
              ]
            }
            fontWeight={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-text-font-weight"
              ]
            }
          />
        </Grid>
        {/* ************************************ */}
        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Secondary Button Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Secondary Button"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-bg"
              ]
            }
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <BrandingInputField
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Secondary Button Border Radius"}
            fieldValue={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary_btn-border-radius"
              ]
            }
          />
        </Grid>

        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Secondary Button Border"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-border-color"
              ]
            }
          />
        </Grid>
        {/* ****************************************** */}
        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Secondary Button Text Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <BrandingCommonForm
            productParams={productParams}
            setProductParams={setProductParams}
            field={"secondary-button"}
            textColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-text-color"
              ]
            }
            fontFamily={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-text-font-family"
              ]
            }
            fontSize={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-text-font-size"
              ]
            }
            fontStyle={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-text-font-style"
              ]
            }
            fontWeight={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-text-font-weight"
              ]
            }
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Background Colors
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Main Background"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-agent-bg"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Card Background"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-popup-dialog-card-bg"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Card Border"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-card-border-color"
              ]
            }
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <BrandingInputField
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Card Border Radius"}
            fieldValue={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-card-border-radius"
              ]
            }
          />
        </Grid>

        {/* <Grid item xs={12} sm={3}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"primary button"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-primary-button-bg"
              ]
            }
          />
        </Grid> */}
        {/* <Grid item xs={12} sm={3}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"secondary button"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-secondary-button-bg"
              ]
            }
          />
        </Grid> */}
        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Input Field Styles
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"InputField Text"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-field-text-color"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"InputField Background"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-field-bg-color"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"InputField Border"}
            bgColor={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-border-color"
              ]
            }
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <BrandingInputField
            productParams={productParams}
            setProductParams={setProductParams}
            field={"Input Border Radius"}
            fieldValue={
              productParams &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.branding &&
              productParams.products[0].feedbackAgentSettings.branding[
                "branding-cuvo-input-border-radius"
              ]
            }
          />
        </Grid>
        {/* {productParams && productParams.products && productParams.products[0] && productParams.products[0].platform != PLATFORM_TYPE_TV && */}
        <>
          <Grid item xs={12} sm={12}>
            <Typography className="title-sm brandingmain">
              Card's Icon Svg Style
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
            <BrandingBackgrountColor
              productParams={productParams}
              setProductParams={setProductParams}
              field={"Card Svg Foreground"}
              bgColor={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-card-svg-fg-color"
                ]
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
            <BrandingBackgrountColor
              productParams={productParams}
              setProductParams={setProductParams}
              field={"Card Svg Background"}
              bgColor={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-card-svg-bg-color"
                ]
              }
            />
          </Grid>
        </>
        {/* } */}
        <>
          <Grid item xs={12} sm={12}>
            <Typography className="title-sm brandingmain">
              Rating Stars Color Styles
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
            <BrandingBackgrountColor
              productParams={productParams}
              setProductParams={setProductParams}
              field={"Selected Star"}
              bgColor={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-selected-star-color"
                ]
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
            <BrandingBackgrountColor
              productParams={productParams}
              setProductParams={setProductParams}
              field={"Unselected Star"}
              bgColor={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-unselected-star-color"
                ]
              }
            />
          </Grid>
        </>
        <>
          <Grid item xs={12} sm={12}>
            <Typography className="title-sm brandingmain">
              Rating Stars Image
            </Typography>
            <Typography className="fullwidth" sx={{ fontSize: "9px", mt: 0.7 }}>
              (If you want to use the default image, leave the fields below
              blank.)
            </Typography>
          </Grid>
          <Grid item xs={24}>
            <BrandingInputField
              productParams={productParams}
              setProductParams={setProductParams}
              field={"URI of Selected Start Rating"}
              fieldValue={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-selected-start-rating-uri"
                ]
              }
            />
          </Grid>
          <Grid item xs={24}>
            <BrandingInputField
              productParams={productParams}
              setProductParams={setProductParams}
              field={"URI of Unselected Start Rating"}
              fieldValue={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-unselected-start-rating-uri"
                ]
              }
            />
          </Grid>
        </>

        <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Comments Field Height Styles
          </Typography>
        </Grid>
        {productParams &&
        productParams.products[0] &&
        productParams.products[0].technology != "rokuTv1" ? (
          <Grid item xs={12} sm={3}>
            <BrandingInputField
              productParams={productParams}
              setProductParams={setProductParams}
              field={"CommentsField Height"}
              fieldValue={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-comments-field-height"
                ]
              }
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={3}>
            <BrandingInputField
              productParams={productParams}
              setProductParams={setProductParams}
              field={"CommentsField Height"}
              fieldValue={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-comments-field-height"
                ] &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-comments-field-height"
                ].replace("px", "")
              }
            />
          </Grid>
        )}
        {/* {productParams && productParams.products && productParams.products[0] && productParams.products[0].platform != PLATFORM_TYPE_TV && */}
        <>
          <Grid item xs={12} sm={12}>
            <Typography className="title-sm brandingmain">
              Banner & Message Text Fonts
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <BrandingFontSizeField
              productParams={productParams}
              setProductParams={setProductParams}
              field={"Font Size"}
              fieldValue={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-editor-font-size"
                ]
              }
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <BrandingInputField
              productParams={productParams}
              setProductParams={setProductParams}
              field={"Banner Font Family"}
              fieldValue={
                productParams &&
                productParams.products[0] &&
                productParams.products[0].feedbackAgentSettings &&
                productParams.products[0].feedbackAgentSettings.branding &&
                productParams.products[0].feedbackAgentSettings.branding[
                  "branding-cuvo-editor-font-family"
                ]
              }
            />
          </Grid>
        </>
        {/* } */}

        {/* <Grid item xs={12} sm={12}>
          <Typography className="title-sm brandingmain">
            Border Styling
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <BrandingBackgrountColor
            productParams={productParams}
            setProductParams={setProductParams}
            field={"card border"}
            bgColor={productParams && productParams.products[0] && productParams.products[0].feedbackAgentSettings && productParams.products[0].feedbackAgentSettings.branding && productParams.products[0].feedbackAgentSettings.branding['branding-cuvo-card-border-color']}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl className="custom-select" fullWidth>
            <InputLabel>Card Border Radius </InputLabel>
            <Select
              name={`radius`}
              value={productParams && productParams.products[0] && productParams.products[0].feedbackAgentSettings && productParams.products[0].feedbackAgentSettings.branding && productParams.products[0].feedbackAgentSettings.branding['branding-cuvo-card-border-radius']}
              onChange={(event) => {
                handleCardBoderRadius(event);
              }}
            >
              {Array.from(Array(50)).map((_, i) => (
                <MenuItem key={1} value={i + 1 + "px"}>
                  {i + 1}px
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl className="custom-select" fullWidth>
            <InputLabel>Button Border Radius </InputLabel>
            <Select
              name={`radius`}
              value={productParams && productParams.products[0] && productParams.products[0].feedbackAgentSettings && productParams.products[0].feedbackAgentSettings.branding && productParams.products[0].feedbackAgentSettings.branding['branding-cuvo-button-border-radius']}
              onChange={(event) => {
                handleButtonBoderRadius(event);
              }}
            >
              {Array.from(Array(50)).map((_, i) => (
                <MenuItem key={1} value={i + 1 + "px"}>
                  {i + 1}px
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
      </Grid>
      {/* *****************Form Appreance************************************** */}
    </>
  );
};

export default BrandingAgent;
